import { Component, Inject } from '@angular/core';
import { FormBuilder, FormControl, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { dropdownData } from 'app/shared/models/types/types';

@Component({
  selector: 'app-dialog-choose-dropdown',
  templateUrl: './dialog-choose-dropdown.component.html',
  styleUrls: ['./dialog-choose-dropdown.component.scss']
})
export class DialogChooseDropdownComponent {
  list: any;
  form: UntypedFormGroup;

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<DialogChooseDropdownComponent>,
    @Inject(MAT_DIALOG_DATA) public data: dropdownData
  ) {

  }

  ngOnInit(): void {
    this.list = this.data.list;
    this.form = this.fb.group({
      choosenOne: new FormControl(null, Validators.required)
    })
  }

  getControl(control: string): UntypedFormControl {
    return this.form.get(control) as UntypedFormControl;
  }

  onConfirm(): void { this.dialogRef.close(this.form.value.choosenOne); }
  onDismiss(): void { this.dialogRef.close(false); }
}
